export const queryKeys = {
  groups: "groups",
  group_users: "group-users",
  group: "group",
  users: "entity-users",
  messages: "messages",
  searchUsers: "searchUsers",
  plans: "plans",
  entityPreferences: "entityPreferences",
  trackerOptions: "tracker-options",
  esignatureTemplates: "esignature-templates",
  esignatureDocuments: "esignature-documents",
  emailQuota: "email-quota",
  groupUsersCount: "group-users-count",
};
